// @flow
import * as React from 'react';
import style from './Loader.scss';

type Props = {
  size?: string,
  thickness?: string,
  duration?: string,
};

const Loader = ({
  size,
  fallbackText,
  thickness,
  duration: animationDuration,
}: Props) => (
  <div
    className={style.loader}
    style={{
      width: size,
      height: size,
      borderWidth: thickness,
      animationDuration,
    }}
  />
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Common/Loader.js